import React from "react";

function Info({ productDetails }) {
  return (
    <div className={`ml-[1.25rem] admin-text-editor`}>
      {productDetails && (
        <div
          dangerouslySetInnerHTML={{
            __html: `${productDetails}`,
          }}
        ></div>
      )}
    </div>
  );
}

export default Info;
